import React, { Component } from "react";
import { Home, ChevronRight } from "react-feather";
import { Link } from "react-router-dom";

export class Breadcrumb extends Component {
  render() {
    const { title, parent } = this.props;

    // Truncate for the trail label (right side)
    const trailLabel =
      title && title.length > 36 ? title.slice(0, 36).trim() + "…" : title;

    return (
      <div className="container-fluid kd-crumb-wrap">
        <div className="kd-crumb">
          <span className="kd-crumb-ring" aria-hidden="true" />
          <div className="kd-crumb-text">
            {parent && <span className="kd-crumb-parent">{parent}</span>}
            <h3 className="kd-crumb-title">{title || "—"}</h3>
          </div>

          <nav className="kd-crumb-trail" aria-label="Breadcrumb">
            <Link to="/dashboard" className="kd-crumb-chip" aria-label="Dashboard">
              <Home size={13} />
            </Link>
            {parent && (
              <>
                <ChevronRight size={12} className="kd-crumb-sep" aria-hidden="true" />
                <span className="kd-crumb-chip">{parent}</span>
              </>
            )}
            {title && (
              <>
                <ChevronRight size={12} className="kd-crumb-sep" aria-hidden="true" />
                <span className="kd-crumb-chip kd-crumb-chip--current" title={title}>
                  {trailLabel}
                </span>
              </>
            )}
          </nav>
        </div>
      </div>
    );
  }
}

export default Breadcrumb;
